import { memo, useEffect, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import CreateUi from "./CreateUi";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import {
  addUserApi,
  getUserByIdApi,
  updateUserField,
} from "../../apis/user.api";
import { closeModal } from "../../store/actions/modalAction";
import { useParams } from "react-router-dom";
import { REGIONS_TYPE, SNACK_BAR_VARIETNS, USER_ROLES } from "../../utils/constants";
import {
  addSecretsApi,
  getSecretsByIdApi,
  updateSecretsField,
} from "../../apis/secrets.api";
import { findObjectKeyByValue } from "../../utils/helper";
import { addRegionApi, getRegionByIdApi, updateRegionApi } from "../../apis/region.api";
import { callSnackBar } from "../../store/actions/snackbarAction";

const CreateController = ({ callBack = () => { }, id, type }) => {
  const validate = useValidate();
  const dispatch = useDispatch();
  const params = useParams();

  const title = "Regions ";
  const modalKey = "region";
  const createApi = addRegionApi;
  const updateApi = updateRegionApi;
  const getByIdApi = getRegionByIdApi;

  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true)
  const [fields, setFields] = useState({
    err: "",
    id,
    name: "",
    short_name: "",
    type: type ?? REGIONS_TYPE.COUNTRY,
    parent: null,
  });
  const [originalDocument, setOriginalDocument] = useState({});

  const validationSchemaForCreate = useMemo(
    () => [
      {
        required: true,
        value: fields.name,
        field: "Region Name",
      },
      {
        required: true,
        value: fields.short_name,
        field: "Short Name",
      },
      {
        required: true,
        value: fields.type,
        field: "Region Type",
      },

      {
        required: fields.type != REGIONS_TYPE.COUNTRY && true,
        value: fields.parent,
        field:
          (findObjectKeyByValue(fields.type, REGIONS_TYPE) ?? "Parent ") +
          " Region",
      },
    ],
    [fields]
  );

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.name,
        field: "Name",
      },
      {
        required: true,
        value: fields.short_name,
        field: "Short Name",
      },
    ],
    [fields]
  );

  const createFunction = async () => {
    const validationResponse = validate(validationSchemaForCreate);

    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await createApi(fields),
          async (response) => {
            await callBack(response);
            setLoading(false);
            dispatch(closeModal(modalKey));
            dispatch(callSnackBar('Create Successfully.', SNACK_BAR_VARIETNS.suceess))
          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          }
        )
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const updateFunction = async () => {
    const validationResponse = validate(validationSchemaForUpdate)
    let updatedData = { id }

    for (let field in fields) {

      if (originalDocument[field] && fields[field] && fields[field] != originalDocument[field]) {
        const fieldVal = fields[field]
        updatedData[field] = typeof fieldVal == "object" ? fieldVal['_id'] : fieldVal
      }
      if (!originalDocument[field] && fields[field]) {
        updatedData[field] = fields[field]
      }
    }
    if (validationResponse === true) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await updateApi(updatedData),
          async (response) => {
            await callBack(response, updatedData);
            setLoading(false);
            dispatch(closeModal(modalKey));
            dispatch(callSnackBar('Update Successfully.', SNACK_BAR_VARIETNS.suceess))

          },
          (err) => {
            setLoading(false);
            setFields({ ...fields, err });
          }
        )
      );
    } else {
      setFields({ ...fields, err: validationResponse });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (id) {
      updateFunction();
    } else {
      createFunction();
    }
  };

  const fetchById = (id) => {
    setFetchLoading(true);
    dispatch(
      callApiAction(
        async () => await getByIdApi({ id }),
        async (response) => {
          setFields({ ...fields, ...response });
          setOriginalDocument(response);
          setFetchLoading(false);
        },
        (err) => {
          setFields({ ...fields, err });
          setFetchLoading(false);
        }
      )
    );
  };

  useEffect(() => {
    if (id) fetchById(id);
  }, [id]);

  return (
    <CreateUi
      modalKey={modalKey}
      title={title}
      isUpdate={id}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
    />
  );
};
export default memo(CreateController);
